import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';

const UnstyledStateText = dynamic(() => import('./unstyled-state-text'));

Builder.registerComponent(UnstyledStateText, {
  name: 'UnstyledStateText',
  friendlyName: 'Unstyled State Text',
  inputs: [
    {
      name: 'content',
      type: 'string',
      friendlyName: 'Content',
      helperText:
        'Anything after a caret (^) will be in the accent color. {{state}} will be replace with the state name.',
    },
    { name: 'accentColor', type: 'color', friendlyName: 'Accent Color' },
    {
      name: 'fallbackState',
      type: 'string',
      friendlyName: 'Fallback Location',
    },
    {
      name: 'maxStateLength',
      type: 'number',
      friendlyName: 'Max State Length',
      defaultValue: 8,
      helperText:
        'If the state name length is longer than this value it will use the state acronym. Defaults to 8.',
    },
  ],
});
